module.exports = __webpack_public_path__ + "static/media/karachi-r5.9cc739fe.svg";